/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useLang } from '_metronic/i18n/Metronici18n'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
import { sidebarMenuItems } from 'Configuration/Menu'

export function AsideMenuMain() {
	const lang = useLang()

	return (
		<React.Fragment>
			{/* begin:: Dashboard */}
			<AsideMenuItemWithSub
				to="dashboard"
				// @ts-ignore
				title={sidebarMenuItems['dashboard'][lang]}
				icon="/media/icons/kumopack/home-04.svg">
				<AsideMenuItem to="/dashboard/production" title="การสั่งผลิต (OEM)" hasBullet />
				<AsideMenuItem to="/dashboard/retail" title="ตลาดซื้อขาย (MKP)" hasBullet />
			</AsideMenuItemWithSub>
			{/* end:: Dashboard */}

			{/* begin:: OEM */}
			<AsideMenuItemWithSub
				to="/oem/orders/oem/productions"
				// @ts-ignore
				title={sidebarMenuItems['oem'][lang]}
				icon="/media/icons/kumopack/container.svg">
				<AsideMenuItem to="/oem/orders" title="ออร์เดอร์ของฉัน" hasBullet />
				<AsideMenuItem to="/oem/productions" title="การผลิตของฉัน" hasBullet />
			</AsideMenuItemWithSub>
			{/* end:: OEM */}

			{/* begin:: Production */}
			<AsideMenuItemWithSub
				to="/general"
				// @ts-ignore
				title={sidebarMenuItems['production'][lang]}
				icon="/media/icons/kumopack/info-circle.svg">
				<AsideMenuItem to="/general/production" title="Production" hasBullet />
				{/* <AsideMenuItem to="/general/sustainability" title="Sustainability Options" hasBullet /> */}
				{/* <AsideMenuItem to="/general/certification" title="Certification Options" hasBullet /> */}
			</AsideMenuItemWithSub>
			{/* end:: Production */}

			{/* begin:: Marketplace */}
			<AsideMenuItemWithSub
				to="marketplace/orders/marketplace/coupons"
				// @ts-ignore
				title={sidebarMenuItems['marketplace'][lang]}
				icon="/media/icons/kumopack/container.svg">
				<AsideMenuItem to="/marketplace/orders" title="คำสั่งซื้อของฉัน" hasBullet />
				<AsideMenuItem to="/marketplace/coupons" title="ส่วนลดคูปอง" hasBullet />
			</AsideMenuItemWithSub>
			{/* end:: Marketplace */}

			{/* begin:: Marketplace Product */}
			<AsideMenuItemWithSub
				to="products"
				// @ts-ignore
				title={sidebarMenuItems['retail'][lang]}
				icon="/media/icons/kumopack/shopping-bag-01.svg">
				<AsideMenuItem to="/products/all" title="สินค้าของฉัน" hasBullet />
				<AsideMenuItem to="/products/new" title="เพิ่มสินค้าใหม่" hasBullet />
			</AsideMenuItemWithSub>
			{/* end:: Marketplace Product */}

			{/* begin:: Document */}
			<AsideMenuItemWithSub
				to="documents"
				// @ts-ignore
				title={sidebarMenuItems['document'][lang]}
				icon="/media/icons/kumopack/book-open-02.svg">
				<AsideMenuItem to="/documents/quotation" title="ใบเสนอราคา" hasBullet />
			</AsideMenuItemWithSub>
			{/* end:: Document */}

			{/* begin:: Billing */}
			<AsideMenuItemWithSub
				to="billing"
				// @ts-ignore
				title={sidebarMenuItems['billing'][lang]}
				icon="/media/icons/kumopack/coins-stacked-02.svg">
				<AsideMenuItem to="/billing/oem" title="ภาพรวมบัญชี OEM" hasBullet />
				<AsideMenuItem to="/billing/invoiceoem" title="ใบกำกับภาษี OEM" hasBullet />
				<AsideMenuItem to="/billing/marketplace" title="ภาพรวมบัญชี Marketplace" hasBullet />
				<AsideMenuItem to="/billing/invoicem" title="ใบกำกับภาษี Marketplace" hasBullet />
			</AsideMenuItemWithSub>
			{/* end:: Billing */}
		</React.Fragment>
	)
}
